import React from 'react'

type FlipVariant = 'filled' | 'outlined'

interface FlipButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  variant?: FlipVariant
  fullWidth?: boolean
  children: React.ReactNode
}

/*
  Site-wide 3D-flip CTA button. The visible pill rolls 180° on the X-axis
  on hover/focus, flipping from a filled black face to a white face with a
  thicker black border (or the inverse for the outlined variant).

  Shared mechanism (perspective, grid-stacked faces, backface-visibility,
  font + colour) lives in src/styles/shared/flip-button.css. Per-call-site
  sizing is supplied via --flip-* CSS custom properties on the existing
  className passed in.
*/
const FlipButton = React.forwardRef<HTMLButtonElement, FlipButtonProps>(
  function FlipButton(
    {
      variant = 'filled',
      fullWidth,
      className = '',
      children,
      type = 'button',
      ...props
    },
    ref,
  ) {
    return (
      <button
        ref={ref}
        type={type}
        {...props}
        className={`mig-flip-button ${className}`.trim()}
        data-variant={variant}
        data-full-width={fullWidth ? 'true' : undefined}
      >
        <span className="mig-flip-button-flip" aria-hidden="true">
          <span className="mig-flip-button-face mig-flip-button-face-front">
            {children}
          </span>
          <span className="mig-flip-button-face mig-flip-button-face-back">
            {children}
          </span>
        </span>
      </button>
    )
  },
)

export default FlipButton
